import { useState } from "react";
import { ChairIcon } from "~/icons/ChairIcon";
import { DoorIcon } from "~/icons/DoorIcon";
import { PeopleIcon } from "~/icons/PeopleIcon";
import { BuildingIcon } from "~/icons/BuildingIcon";
import { ArrowSquareIcon } from "~/icons/ArrowSquareIcon";
import { PinIcon } from "~/icons/PinIcon";
import { CircleArrowIcon } from "~/icons/CircleArrow";
import { StarRating } from "~/components/StarRating";
import { SquareIcon } from "~/icons/SquareIcon";
import { SquareInSquareIcon } from "~/icons/SquareInSquareIcon";
import { RichTextRenderer } from "~/components/RichTextRenderer";
import { withLocale } from "~/lib/utils/with-locale";

type LocationRating = {
  rating: number;
  reviewsCount: number;
};

type LocationAddress = {
  street?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  country?: string;
  mapUrl?: string;
};

type LocationStats = {
  totalRooms: string;
  capacitySeated: string;
  capacityStanding: string;
  insideAreaSum: string;
  biggestRoom: string;
  outsideAreaSum: string;
  outsideLargestArea: string;
};

interface LocationDetailProps {
  description?: string;
  stats?: LocationStats;
  address?: LocationAddress;
  rating?: LocationRating;
}

type LocationStatKey = keyof LocationStats;
const items: {
  icon: React.ReactNode;
  label: string;
  valueKey: LocationStatKey;
}[] = [
  {
    icon: <BuildingIcon />,
    label: "m² Innenfläche gesamt",
    valueKey: "insideAreaSum",
  },
  {
    icon: <ArrowSquareIcon />,
    label: "m² Innenfläche größter Raum",
    valueKey: "biggestRoom",
  },
  {
    icon: <SquareIcon />,
    label: "m² Außenfläche gesamt",
    valueKey: "outsideAreaSum",
  },
  {
    icon: <SquareInSquareIcon />,
    label: "m² Außenfläche größte Fläche",
    valueKey: "outsideLargestArea",
  },
  { icon: <DoorIcon />, label: "Veranstaltungsräume", valueKey: "totalRooms" },
  { icon: <PeopleIcon />, label: "max. stehend", valueKey: "capacityStanding" },
  { icon: <ChairIcon />, label: "max. sitzend", valueKey: "capacitySeated" },
];

export function LocationDetail({
  description,
  stats,
  address,
  rating,
}: LocationDetailProps) {
  return (
    <div className="space-y-6">
      {/* Bewertungen */}
      {/* {rating ? (
        <div className="flex items-center gap-3 text-sm text-gray-700">
          <StarRating rating={rating.rating} />
          <span>{rating.reviewsCount} Bewertungen –</span>
          <Link to={withLocale("/")} className="text-lemon-dark font-medium hover:underline">
            Alle lesen
          </Link>
        </div>
      ) : null} */}

      {/* Adresse */}
      {address ? (
        <div className="flex items-center gap-2">
          <PinIcon />
          <span>
            {address.postalCode ? `${address.postalCode} ` : ""}
            {address.city}
            {address.state ? `, ${address.state}` : ""}
            {address.country ? `, ${address.country}` : ""}
            {/* {address.mapUrl && (
              <>
                {" – "}
                <Link
                  to={address.mapUrl}
                  className="text-lemon-dark font-medium hover:underline"
                >
                  Auf der Karte zeigen
                </Link>
              </>
            )} */}
          </span>
        </div>
      ) : null}

      {stats ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-8 py-4 max-w-[600px]">
          {items
            .filter((item) => stats[item.valueKey] !== "0")
            .map((item) => (
              <div
                key={item.label}
                className="flex flex-col items-center text-center"
              >
                <div className="text-3xl">{item.icon}</div>
                <div className="text-lg font-semibold">
                  {stats[item.valueKey]}
                </div>
                <div className="text-xs">{item.label}</div>
              </div>
            ))}
        </div>
      ) : null}

      {/* Beschreibung */}
      {description ? (
        <div className="relative text-sm leading-relaxed">
          <RichTextRenderer richText={description} />
        </div>
      ) : null}
    </div>
  );
}
